import React, { Component } from "react";

import MS from "./../services/Moment";

import { DatePicker } from "element-react";
import "element-theme-default";

import { i18n } from "element-react";
import locale from "element-react/src/locale/lang/ko";
import { withTranslation } from "react-i18next";

i18n.use(locale);

class Date extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value2: null,
    };

    if (typeof this.props.value != "undefined") {
      this.state = {
        value2: MS.toDate(this.props.value, "YYYY-MM-DD"),
      };
    }
  }

  handleChange(dt) {
    this.setState({ value2: dt });
    this.props.handleDateChange(this.props.name, MS.format(dt, "YYYY-MM-DD"));
  }

  render() {
    const { value2 } = this.state;
    const { t } = this.props;
    return (
      <>
        <DatePicker
          name={this.props.name}
          value={value2}
          placeholder={t('key423')}
          align="right"
          ref={(e) => (this.datepicker2 = e)}
          onChange={(date) => this.handleChange(date)}
          shortcuts={[
            {
              text: t('key583'),
              onClick: (picker) => {
                const dt = new Date();
                this.setState({ value2: dt });
                this.datepicker2.togglePickerVisible();
                this.handleChange(dt);
              },
            },
            {
              text: t('key584'),
              onClick: () => {
                const dt = new Date();
                dt.setTime(dt.getTime() - 3600 * 1000 * 24);
                this.setState({ value2: dt });
                this.datepicker2.togglePickerVisible();
                this.handleChange(dt);
              },
            },
            {
              text: t('key585'),
              onClick: () => {
                const dt = new Date();
                dt.setTime(dt.getTime() - 3600 * 1000 * 24 * 7);
                this.setState({ value2: dt });
                this.datepicker2.togglePickerVisible();
                this.handleChange(dt);
              },
            },
          ]}
        />
      </>
    );
  }
}

export default withTranslation()(Date);
